const translations = {
  en: {
    // Navbar
    nav_gallery: "Gallery",
    nav_about: "About",
    nav_reviews: "Reviews",
    nav_contact: "Contact",
    nav_admin: "Admin",
    nav_logout: "Logout",
    nav_client_login: "Client Login",

    // Hero
    hero_subtitle: "Tattoo Studio",
    hero_tagline: "Where precision meets artistry. Every stroke tells a story, every design is a masterpiece inked with purpose.",
    hero_book: "Book Now",
    hero_view: "View Work",
    hero_login: "Login",

    // About
    about_subtitle: "About Us",
    about_title_1: "Ink is Permanent.",
    about_title_2: "The Experience Should Be Too.",
    about_text: "Purple INK is more than a tattoo studio. It's a sanctuary for self-expression where artistry meets precision. Founded with the belief that every mark on your body should carry meaning, weight, and beauty.",
    about_body2: "Our artists bring years of experience across every style imaginable. Whether it's your first piece or your hundredth, we treat every session with the same dedication and care.",
    about_feat_custom: "Custom Designs",
    about_feat_custom_desc: "Every piece is tailored to you. No flash, no repeats. Pure originality inked on skin.",
    about_feat_safe: "Sterile & Safe",
    about_feat_safe_desc: "Hospital-grade sterilization. Single-use needles. Your safety is non-negotiable.",
    about_feat_styles: "All Styles",
    about_feat_styles_desc: "From fine-line minimalism to full-color realism. We master every technique.",

    // Gallery
    gallery_subtitle: "Our Work",
    gallery_title: "The Gallery",

    // Reviews
    reviews_subtitle: "Testimonials",
    reviews_title: "What Clients Say",
    reviews_write: "Write a Review",
    reviews_leave: "Leave a Review",
    reviews_name: "Your Name",
    reviews_text: "Your review...",
    reviews_share: "Share your experience...",
    reviews_submit: "Submit Review",
    reviews_submitting: "Submitting...",
    reviews_no: "No reviews yet. Be the first!",
    reviews_no_exp: "No reviews yet. Be the first to share your experience.",

    // Contact
    contact_subtitle: "Get In Touch",
    contact_ready: "Ready for Your",
    contact_next_piece: "Next Piece?",
    contact_body: "Drop us a message or book directly through our Instagram. We respond within 24 hours.",
    contact_name: "Your name",
    contact_email: "Your email",
    contact_message: "Tell us about your idea...",
    contact_send: "Send Message",
    contact_sending: "Sending...",
    contact_social: "Follow Us",
    contact_book_dm: "Book via DM",
    contact_studio_loc: "Studio Location",
    contact_open_hours: "Open Hours",

    // Footer
    footer_rights: "All rights reserved.",

    // Login
    login_title: "Welcome Back",
    login_subtitle: "Sign in to your account to access your rewards and referrals.",
    login_email: "Username",
    login_password: "Password",
    login_submit: "Sign In",
    login_no_account: "Don't have an account? Contact the studio to get started.",

    // Client Dashboard
    dash_subtitle: "Client Dashboard",
    dash_title: "Your Rewards",
    dash_artist: "Your Artist",
    dash_discount: "Current Discount",
    dash_referrals_made: "Referrals Made",
    dash_referrals_remaining: "Referrals Remaining",
    dash_progress: "Discount Progress",
    dash_progress_text: "Refer {n} more friends to reach the maximum 65% discount.",
    dash_referral_code: "Your Referral Code",
    dash_referral_share: "Share this code with friends. Each referral gives you +10% discount.",
    dash_care_title: "Tattoo Care Instructions",
    dash_care_desc: "Download your personalized aftercare guide to keep your tattoo looking fresh.",
    dash_care_btn: "Download PDF",
    dash_qr_title: "Your Personal QR Code",
    dash_qr_desc: "Show this QR code to your tattoo artist when you visit the salon to claim your discount.",
    dash_qr_ready: "Current discount ready to claim",
    dash_claim_title: "Claiming History",
    dash_claim_desc: "Record of all your claimed discounts.",
    dash_claim_item: "{pct}% discount claimed",
    dash_referral_title: "Referral History",
    dash_copied: "Copied!",
    dash_share_whatsapp: "Share via WhatsApp",
    dash_share_sms: "Share via SMS",
    dash_share_msg: "Hey! Use my referral code {code} at Purple INK Tattoo Studio and we both get rewarded! Book your session now.",

    // Admin Panel
    admin_master_label: "Master Administration",
    admin_artist_label: "Artist Panel",
    admin_title: "Admin Panel",
    admin_welcome: "Welcome, {name}",
    tab_dashboard: "Dashboard",
    tab_clients: "Clients",
    tab_new_client: "New Client",
    tab_referrals: "Referrals",
    tab_scan_qr: "Scan QR",
    tab_artists: "Artists",
    tab_gallery: "Gallery",
    tab_reviews: "Reviews",
    tab_messages: "Messages",
    tab_settings: "Settings",
    tab_audit: "Audit Log",

    // Dashboard stats
    stat_total_clients: "Total Clients",
    stat_active_discounts: "Active Discounts",
    stat_total_referrals: "Total Referrals",
    stat_referrals_month: "Referrals This Month",
    stat_new_clients_30: "New Clients (Last 30 Days)",
    stat_discount_dist: "Discount Distribution",
    stat_activity_7: "Activity (Last 7 Days)",
    stat_recent_activity: "Recent Activity",
    filter_all_artists: "All Artists (Platform Total)",
    chart_no_new: "No new clients in the last 30 days",
    chart_30d: "30d ago",
    chart_today: "Today",
    chart_no_clients: "No clients yet",

    // Clients tab
    clients_search: "Search by name, username, email, or code...",
    clients_all_artists: "All Artists",
    clients_export: "Export CSV",
    clients_exporting: "Exporting...",
    clients_master: "Master Admin",
    col_name: "Name",
    col_username: "Username",
    col_email: "Email",
    col_discount: "Discount",
    col_referrals: "Referrals",
    col_code: "Code",
    col_artist: "Artist",
    col_date: "Date",
    col_actions: "Actions",
    btn_claim: "Claim",
    btn_history: "History",
    unassigned: "Unassigned",
    no_clients_search: "No clients match your search",
    no_clients: "No clients yet",
    clients_page_info: "{count} clients",

    // New Client
    new_client_title: "Create New Client",
    new_client_desc: "Password is auto-generated. Download the certificate to print.",
    new_client_name: "Full Name *",
    new_client_email: "Email Address *",
    new_client_discount: "Initial Discount %",
    new_client_submit: "Create Client",
    new_client_creating: "Creating...",
    new_client_creds: "Client Created",
    new_client_creds_desc: "Download and print the certificate for your client.",
    new_client_username: "Username",
    new_client_password: "Password",
    new_client_download: "Download Certificate (JPG)",
    new_client_another: "Create Another",
    new_client_send_email: "Send to Email",
    new_client_send_cert: "Send Certificate",
    new_client_sending: "Sending...",
    new_client_email_invalid: "Invalid email format \u2014 please check the address",

    // Referrals
    referrals_title: "Add Referral",
    referrals_desc: "Enter the client's referral code to add a +10% discount bonus (max 65%).",
    referrals_code: "Referral Code *",
    referrals_name: "New Client Name (optional)",
    referrals_submit: "Add Referral",
    referrals_adding: "Adding...",

    // Scan QR
    scan_title: "Scan Client QR Code",
    scan_desc: "Point your camera at the client's QR code to quickly claim their discount.",
    scan_start: "Start Camera",
    scan_stop: "Stop Camera",
    scan_verified: "QR Code Verified",
    scan_client: "Client",
    scan_discount: "Discount",
    scan_referrals: "Referrals",
    scan_artist: "Artist",
    scan_claim_q: "Claim {pct}% discount for this client? This will reset their discount to 5%.",
    scan_cancel: "Cancel",
    scan_claiming: "Claiming...",
    scan_claim_btn: "Claim {pct}%",
    scan_no_discount: "This client has no discount to claim.",
    scan_another: "Scan Another",

    // Artists tab
    artists_add: "Add Tattoo Artist",
    artists_add_desc: "Create an admin account for a tattoo artist. Email will be auto-generated as",
    artists_name: "Artist Name *",
    artists_password: "Password * (min 6 chars)",
    artists_create: "Create Artist",
    artists_creating: "Creating...",
    artists_login_email: "Login email",
    artists_active: "Active Artists",
    artists_no: "No artist accounts yet",
    artists_password_btn: "Password",
    artists_remove: "Remove",
    artists_clients: "client",
    artists_clients_pl: "clients",
    artists_performance: "Performance Report",
    perf_artist: "Artist",
    perf_role: "Role",
    perf_clients: "Clients",
    perf_referrals: "Total Referrals",
    perf_discounts: "Active Discounts",
    perf_claims: "Claims Made",
    perf_master: "Master",
    perf_artist_role: "Artist",

    // Gallery Admin
    gallery_upload: "Upload Image",
    gallery_title_label: "Title *",
    gallery_category: "Category",
    gallery_image_file: "Image File *",
    gallery_uploading: "Uploading...",
    gallery_upload_btn: "Upload Image",
    gallery_current: "Current Gallery",
    gallery_no_images: "No gallery images uploaded yet",
    gallery_remove: "Remove",

    // Reviews Admin
    admin_reviews_no: "No reviews yet",

    // Messages Admin
    messages_no: "No messages yet",

    // Reassign
    reassign_title: "Reassign Client",
    reassign_desc: "Move {name} to a different artist.",
    reassign_current: "Currently assigned to",
    reassign_select: "Select artist...",
    reassign_master: "Master Admin",
    reassign_confirm: "Reassign",

    // Reset Password
    reset_pw_title: "Reset Password",
    reset_pw_desc: "Set a new password for {name}",
    reset_pw_placeholder: "New password (min 6 chars)",
    reset_pw_confirm: "Reset Password",

    // Delete
    delete_title: "Delete Client",
    delete_desc: "Are you sure you want to delete {name}? This will remove all their data including referrals and discount history.",
    delete_cancel: "Cancel",
    delete_proceed: "Yes, Delete",
    delete_final: "Final Confirmation",
    delete_permanent: "This action is permanent and irreversible.",
    delete_permanent_text: "{name} ({info}) will be permanently deleted.",
    delete_confirm: "Permanently Delete",

    // Settings
    settings_title: "Site Settings",
    settings_save: "Save Settings",
    settings_saving: "Saving...",
    settings_reviews_section: "Reviews Section",
    settings_reviews_desc: "Toggle the reviews section on the landing page",
    settings_social: "Social & Contact",
    settings_instagram_url: "Instagram URL",
    settings_instagram_handle: "Instagram Handle",
    settings_location: "Location / Address",
    settings_open_hours: "Open Hours",
    settings_phone: "Phone",
    settings_page_content: "Page Content",
    settings_hero_desc: "Hero Description",
    settings_about_text: "About Section Text",
    settings_admin_pw: "Admin Password",
    settings_admin_pw_desc: "Change your admin login password",
    settings_pw_change: "Change",

    // Change Password
    change_pw_title: "Change Password",
    change_pw_current: "Current password",
    change_pw_new: "New password (min 6 chars)",
    change_pw_confirm_new: "Confirm new password",
    change_pw_confirm_btn: "Update Password",
    change_pw_changing: "Changing...",

    // Audit Log
    audit_title: "Audit Log",
    audit_filter: "Filter by action...",
    audit_all: "All Actions",
    audit_refresh: "Refresh",
    audit_timestamp: "Timestamp",
    audit_action: "Action",
    audit_actor: "Actor",
    audit_details: "Details",
    audit_filter_actor: "Filter by actor...",
    audit_entries: "entries",
    audit_clear: "Clear",
    audit_no_logs: "No audit logs yet",
    audit_no_match: "No logs match your filters",

    // History Dialog
    history_title: "{name} \u2014 History",
    history_default: "Client History",
    history_subtitle: "Discount claims and referral activity",
    history_current_disc: "Current Discount",
    history_total_ref: "Total Referrals",
    history_claims_made: "Claims Made",
    history_disc_claims: "Discount Claims",
    history_no_claims: "No discounts claimed yet",
    history_pct_claimed: "{pct}% discount claimed",
    history_refs_at_time: "{count} referral(s) at time of claim",
    history_ref_activity: "Referral Activity",
    history_no_refs: "No referrals yet",
    history_referred: "Referred",

    // Stanelo
    stanelo_master: "Stanelo (Master)",

    // GDPR Consent
    gdpr_title: "Data Privacy Consent",
    gdpr_text: "Your username ({username}) is generated from your email address and stored securely. By continuing, you consent to the storage and processing of this personal data in accordance with GDPR regulations.",
    gdpr_accept: "I Accept",
    gdpr_purpose: "Purpose: Account identification for the Purple INK loyalty and referral program.",

    // Cookie Consent
    cookie_banner: "We use essential cookies to ensure the proper functioning of this website. By continuing to browse, you accept our use of cookies.",
    cookie_accept: "Accept",
    cookie_policy_link: "Cookie Policy",
    cookie_policy_title: "Cookie Policy",
    cookie_policy_intro: "This Cookie Policy explains how Purple INK Tattoo Studio uses cookies and similar technologies on our website.",
    cookie_what_title: "What Are Cookies?",
    cookie_what_text: "Cookies are small text files placed on your device when you visit a website. They help the site remember your preferences and improve your browsing experience.",
    cookie_types_title: "Cookies We Use",
    cookie_essential_title: "Essential Cookies",
    cookie_essential_text: "These cookies are necessary for the website to function properly. They enable core features such as authentication, language preferences, and session management. These cookies do not collect personal data for marketing purposes.",
    cookie_list_auth: "Authentication token (JWT) — keeps you logged in securely",
    cookie_list_lang: "Language preference — remembers your EN/RO choice",
    cookie_list_cookie: "Cookie consent — remembers your cookie acceptance",
    cookie_list_gdpr: "GDPR consent — records your data privacy acceptance",
    cookie_third_title: "Third-Party Cookies",
    cookie_third_text: "We do not use any third-party tracking, analytics, or advertising cookies.",
    cookie_rights_title: "Your Rights",
    cookie_rights_text: "You can delete cookies at any time through your browser settings. Note that disabling essential cookies may affect the functionality of the website.",
    cookie_contact_title: "Contact",
    cookie_contact_text: "If you have questions about our cookie practices, please contact us through the Contact section of our website.",
    cookie_updated: "Last updated: February 2026",

    // Admin Consent Column
    col_consent: "Consent",
    consent_yes: "Given",
    consent_no: "Pending",

    // Appointments
    tab_appointments: "Appointments",
    apt_title: "Appointments Calendar",
    apt_new: "New Appointment",
    apt_date: "Date",
    apt_time: "Time",
    apt_duration: "Duration (hours)",
    apt_client_name: "Client Name *",
    apt_phone: "Phone (optional)",
    apt_phone_note: "Auto-deleted after appointment time",
    apt_description: "Tattoo Description",
    apt_advance: "Advance Paid",
    apt_advance_amount: "Amount",
    apt_price: "Price",
    apt_remaining: "Remaining",
    apt_paid_full: "Paid in full",
    apt_create: "Create Appointment",
    apt_creating: "Creating...",
    apt_edit: "Edit Appointment",
    apt_save: "Save Changes",
    apt_saving: "Saving...",
    apt_delete: "Delete",
    apt_delete_confirm: "Delete this appointment for {name} on {date}?",
    apt_reassign: "Reassign",
    apt_reassign_title: "Reassign Appointment",
    apt_reassign_desc: "Move this appointment to a different artist.",
    apt_no: "No appointments for this date",
    apt_no_upcoming: "No upcoming appointments",
    apt_today: "Today",
    apt_phone_hidden: "Number removed",
    apt_all_artists: "All Artists",
    apt_filter_artist: "Filter by artist",
    apt_upcoming: "Upcoming",
    apt_past: "Past",
    apt_reschedule: "Reschedule",
  },

  ro: {
    // Navbar
    nav_gallery: "Galerie",
    nav_about: "Despre Noi",
    nav_reviews: "Recenzii",
    nav_contact: "Contact",
    nav_admin: "Admin",
    nav_logout: "Deconectare",
    nav_client_login: "Autentificare",

    // Hero
    hero_subtitle: "Studio de Tatuaje",
    hero_tagline: "Unde precizia intalneste arta. Fiecare linie spune o poveste, iar fiecare design reprezinta o capodopera facuta cu scop.",
    hero_book: "Programeaza-te",
    hero_view: "Vezi Lucrarile",
    hero_login: "Autentificare",

    // About
    about_subtitle: "Despre Noi",
    about_title_1: "Cerneala e Permanenta.",
    about_title_2: "Experienta ar trebui sa fie la fel.",
    about_text: "Purple INK nu este doar un studio de tatuaje. Este un sanctuar al expresiei de sine, unde arta intalneste precizia. Fondat cu convingerea ca fiecare semn de pe corpul tau ar trebui sa aiba semnificatie, greutate si frumusete.",
    about_body2: "Artistii nostri au experienta cu fiecare stil pe care ti-l poti imagina. Fie ca e primul sau al 10-lea tatuaj, tratam fiecare sedinta cu aceeasi dedicare si grija.",
    about_feat_custom: "Design Personalizat",
    about_feat_custom_desc: "Fiecare piesa este creata special pentru tine. Fara sabloane, fara repetari. Originalitate pura pe piele.",
    about_feat_safe: "Steril si Sigur",
    about_feat_safe_desc: "Sterilizare de grad spitalicesc. Ace de unica folosinta. Siguranta ta este non-negociabila.",
    about_feat_styles: "Toate Stilurile",
    about_feat_styles_desc: "De la minimalism fin la realism complet color. Stapanim fiecare tehnica.",

    // Gallery
    gallery_subtitle: "Lucrarile Noastre",
    gallery_title: "Galeria",

    // Reviews
    reviews_subtitle: "Testimoniale",
    reviews_title: "Ce Spun Clientii",
    reviews_write: "Scrie o Recenzie",
    reviews_leave: "Lasa o Recenzie",
    reviews_name: "Numele Tau",
    reviews_text: "Recenzia ta...",
    reviews_share: "Impartaseste experienta ta...",
    reviews_submit: "Trimite Recenzia",
    reviews_submitting: "Se trimite...",
    reviews_no: "Nicio recenzie inca. Fii primul!",
    reviews_no_exp: "Nicio recenzie inca. Fii primul care isi impartaseste experienta.",

    // Contact
    contact_subtitle: "Ia Legatura",
    contact_ready: "Pregatit pentru",
    contact_next_piece: "Urmatoarea Piesa?",
    contact_body: "Trimite-ne un mesaj sau programeaza-te direct prin Instagram. Raspundem in 24 de ore.",
    contact_name: "Numele tau",
    contact_email: "Emailul tau",
    contact_message: "Spune-ne despre ideea ta...",
    contact_send: "Trimite Mesajul",
    contact_sending: "Se trimite...",
    contact_social: "Urmareste-ne",
    contact_book_dm: "Programeaza prin DM",
    contact_studio_loc: "Locatia Studioului",
    contact_open_hours: "Program",

    // Footer
    footer_rights: "Toate drepturile rezervate.",

    // Login
    login_title: "Bine ai Revenit",
    login_subtitle: "Autentifica-te pentru a accesa recompensele si referalurile tale.",
    login_email: "Utilizator",
    login_password: "Parola",
    login_submit: "Autentificare",
    login_no_account: "Nu ai cont? Contacteaza studioul pentru a incepe.",

    // Client Dashboard
    dash_subtitle: "Panoul Clientului",
    dash_title: "Recompensele Tale",
    dash_artist: "Artistul Tau",
    dash_discount: "Discount Curent",
    dash_referrals_made: "Referaluri Facute",
    dash_referrals_remaining: "Referaluri Ramase",
    dash_progress: "Progres Discount",
    dash_progress_text: "Recomanda inca {n} prieteni pentru a atinge discountul maxim de 65%.",
    dash_referral_code: "Codul Tau de Referire",
    dash_referral_share: "Distribuie acest cod prietenilor. Fiecare referire iti aduce +10% discount.",
    dash_care_title: "Instructiuni Ingrijire Tatuaj",
    dash_care_desc: "Descarca ghidul personalizat de ingrijire pentru a-ti pastra tatuajul impecabil.",
    dash_care_btn: "Descarca PDF",
    dash_qr_title: "Codul Tau QR Personal",
    dash_qr_desc: "Arata acest cod QR artistului tau cand vizitezi salonul pentru a revendica discountul.",
    dash_qr_ready: "Discount disponibil pentru revendicare",
    dash_claim_title: "Istoric Revendicari",
    dash_claim_desc: "Evidenta tuturor discounturilor revendicate.",
    dash_claim_item: "Discount de {pct}% revendicat",
    dash_referral_title: "Istoric Referaluri",
    dash_copied: "Copiat!",
    dash_share_whatsapp: "Distribuie pe WhatsApp",
    dash_share_sms: "Distribuie prin SMS",
    dash_share_msg: "Salut! Foloseste codul meu de referire {code} la Purple INK Tattoo Studio si amandoi primim recompense! Programeaza-ti sedinta acum.",

    // Admin Panel
    admin_master_label: "Administrare Principala",
    admin_artist_label: "Panoul Artistului",
    admin_title: "Panou Administrare",
    admin_welcome: "Bine ai venit, {name}",
    tab_dashboard: "Panou",
    tab_clients: "Clienti",
    tab_new_client: "Client Nou",
    tab_referrals: "Referaluri",
    tab_scan_qr: "Scaneaza QR",
    tab_artists: "Artisti",
    tab_gallery: "Galerie",
    tab_reviews: "Recenzii",
    tab_messages: "Mesaje",
    tab_settings: "Setari",
    tab_audit: "Jurnal Audit",

    // Dashboard stats
    stat_total_clients: "Total Clienti",
    stat_active_discounts: "Discounturi Active",
    stat_total_referrals: "Total Referaluri",
    stat_referrals_month: "Referaluri Luna Aceasta",
    stat_new_clients_30: "Clienti Noi (Ultimele 30 Zile)",
    stat_discount_dist: "Distributie Discounturi",
    stat_activity_7: "Activitate (Ultimele 7 Zile)",
    stat_recent_activity: "Activitate Recenta",
    filter_all_artists: "Toti Artistii (Total Platforma)",
    chart_no_new: "Niciun client nou in ultimele 30 de zile",
    chart_30d: "acum 30z",
    chart_today: "Azi",
    chart_no_clients: "Niciun client inca",

    // Clients tab
    clients_search: "Cauta dupa nume, utilizator, email sau cod...",
    clients_all_artists: "Toti Artistii",
    clients_export: "Exporta CSV",
    clients_exporting: "Se exporta...",
    clients_master: "Admin Principal",
    col_name: "Nume",
    col_username: "Utilizator",
    col_email: "Email",
    col_discount: "Discount",
    col_referrals: "Referaluri",
    col_code: "Cod",
    col_artist: "Artist",
    col_date: "Data",
    col_actions: "Actiuni",
    btn_claim: "Revendica",
    btn_history: "Istoric",
    unassigned: "Neatribuit",
    no_clients_search: "Niciun client nu corespunde cautarii",
    no_clients: "Niciun client inca",
    clients_page_info: "{count} clienti",

    // New Client
    new_client_title: "Creeaza Client Nou",
    new_client_desc: "Parola este generata automat. Descarca certificatul pentru imprimare.",
    new_client_name: "Nume Complet *",
    new_client_email: "Adresa Email *",
    new_client_discount: "Discount Initial %",
    new_client_submit: "Creeaza Client",
    new_client_creating: "Se creeaza...",
    new_client_creds: "Client Creat",
    new_client_creds_desc: "Descarca si imprima certificatul pentru clientul tau.",
    new_client_username: "Utilizator",
    new_client_password: "Parola",
    new_client_download: "Descarca Certificat (JPG)",
    new_client_another: "Creeaza Altul",
    new_client_send_email: "Trimite pe Email",
    new_client_send_cert: "Trimite Certificat",
    new_client_sending: "Se trimite...",
    new_client_email_invalid: "Format email invalid \u2014 verifica adresa",

    // Referrals
    referrals_title: "Adauga Referire",
    referrals_desc: "Introdu codul de referire al clientului pentru a adauga un bonus de +10% discount (max 65%).",
    referrals_code: "Cod Referire *",
    referrals_name: "Numele Clientului Nou (optional)",
    referrals_submit: "Adauga Referire",
    referrals_adding: "Se adauga...",

    // Scan QR
    scan_title: "Scaneaza Codul QR",
    scan_desc: "Indreapta camera spre codul QR al clientului pentru a-i revendica rapid discountul.",
    scan_start: "Porneste Camera",
    scan_stop: "Opreste Camera",
    scan_verified: "Cod QR Verificat",
    scan_client: "Client",
    scan_discount: "Discount",
    scan_referrals: "Referaluri",
    scan_artist: "Artist",
    scan_claim_q: "Revendici discountul de {pct}% pentru acest client? Discountul va fi resetat la 5%.",
    scan_cancel: "Anuleaza",
    scan_claiming: "Se revendica...",
    scan_claim_btn: "Revendica {pct}%",
    scan_no_discount: "Acest client nu are discount de revendicat.",
    scan_another: "Scaneaza Alt Cod",

    // Artists tab
    artists_add: "Adauga Artist Tatuator",
    artists_add_desc: "Creeaza un cont de administrator pentru un artist. Emailul va fi generat automat ca",
    artists_name: "Numele Artistului *",
    artists_password: "Parola * (min 6 caractere)",
    artists_create: "Creeaza Artist",
    artists_creating: "Se creeaza...",
    artists_login_email: "Email autentificare",
    artists_active: "Artisti Activi",
    artists_no: "Niciun cont de artist inca",
    artists_password_btn: "Parola",
    artists_remove: "Sterge",
    artists_clients: "client",
    artists_clients_pl: "clienti",
    artists_performance: "Raport Performanta",
    perf_artist: "Artist",
    perf_role: "Rol",
    perf_clients: "Clienti",
    perf_referrals: "Total Referaluri",
    perf_discounts: "Discounturi Active",
    perf_claims: "Revendicari",
    perf_master: "Principal",
    perf_artist_role: "Artist",

    // Gallery Admin
    gallery_upload: "Incarca Imagine",
    gallery_title_label: "Titlu *",
    gallery_category: "Categorie",
    gallery_image_file: "Fisier Imagine *",
    gallery_uploading: "Se incarca...",
    gallery_upload_btn: "Incarca Imagine",
    gallery_current: "Galeria Curenta",
    gallery_no_images: "Nicio imagine incarcata inca",
    gallery_remove: "Sterge",

    // Reviews Admin
    admin_reviews_no: "Nicio recenzie inca",

    // Messages Admin
    messages_no: "Niciun mesaj inca",

    // Reassign
    reassign_title: "Reatribuie Client",
    reassign_desc: "Muta {name} la un alt artist.",
    reassign_current: "Atribuit in prezent la",
    reassign_select: "Selecteaza artist...",
    reassign_master: "Admin Principal",
    reassign_confirm: "Reatribuie",

    // Reset Password
    reset_pw_title: "Reseteaza Parola",
    reset_pw_desc: "Seteaza o parola noua pentru {name}",
    reset_pw_placeholder: "Parola noua (min 6 caractere)",
    reset_pw_confirm: "Reseteaza Parola",

    // Delete
    delete_title: "Sterge Client",
    delete_desc: "Esti sigur ca vrei sa stergi pe {name}? Aceasta actiune va sterge toate datele, inclusiv referalurile si istoricul discounturilor.",
    delete_cancel: "Anuleaza",
    delete_proceed: "Da, Sterge",
    delete_final: "Confirmare Finala",
    delete_permanent: "Aceasta actiune este permanenta si ireversibila.",
    delete_permanent_text: "{name} ({info}) va fi sters permanent.",
    delete_confirm: "Sterge Permanent",

    // Settings
    settings_title: "Setari Site",
    settings_save: "Salveaza Setarile",
    settings_saving: "Se salveaza...",
    settings_reviews_section: "Sectiunea Recenzii",
    settings_reviews_desc: "Activeaza/Dezactiveaza sectiunea de recenzii pe pagina principala",
    settings_social: "Social si Contact",
    settings_instagram_url: "URL Instagram",
    settings_instagram_handle: "Cont Instagram",
    settings_location: "Locatie / Adresa",
    settings_open_hours: "Program",
    settings_phone: "Telefon",
    settings_page_content: "Continut Pagina",
    settings_hero_desc: "Descriere Hero",
    settings_about_text: "Text Sectiunea Despre",
    settings_admin_pw: "Parola Admin",
    settings_admin_pw_desc: "Schimba parola de autentificare admin",
    settings_pw_change: "Schimba",

    // Change Password
    change_pw_title: "Schimba Parola",
    change_pw_current: "Parola curenta",
    change_pw_new: "Parola noua (min 6 caractere)",
    change_pw_confirm_new: "Confirma parola noua",
    change_pw_confirm_btn: "Actualizeaza Parola",
    change_pw_changing: "Se schimba...",

    // Audit Log
    audit_title: "Jurnal Audit",
    audit_filter: "Filtreaza dupa actiune...",
    audit_all: "Toate Actiunile",
    audit_refresh: "Reincarca",
    audit_timestamp: "Data si Ora",
    audit_action: "Actiune",
    audit_actor: "Actor",
    audit_details: "Detalii",
    audit_filter_actor: "Filtreaza dupa actor...",
    audit_entries: "inregistrari",
    audit_clear: "Sterge Filtrele",
    audit_no_logs: "Nicio inregistrare inca",
    audit_no_match: "Nicio inregistrare nu corespunde filtrelor",

    // History Dialog
    history_title: "{name} \u2014 Istoric",
    history_default: "Istoric Client",
    history_subtitle: "Revendicari discount si activitate de referire",
    history_current_disc: "Discount Curent",
    history_total_ref: "Total Referaluri",
    history_claims_made: "Revendicari Facute",
    history_disc_claims: "Revendicari Discount",
    history_no_claims: "Nicio revendicare inca",
    history_pct_claimed: "Discount de {pct}% revendicat",
    history_refs_at_time: "{count} referaluri la momentul revendicarii",
    history_ref_activity: "Activitate Referaluri",
    history_no_refs: "Niciun referaluri inca",
    history_referred: "A recomandat pe",

    // Stanelo
    stanelo_master: "Stanelo (Principal)",

    // GDPR Consent
    gdpr_title: "Consimtamant Protectia Datelor",
    gdpr_text: "Numele tau de utilizator ({username}) este generat din adresa ta de email si este stocat in siguranta. Continuand, iti dai consimtamantul pentru stocarea si procesarea acestor date personale in conformitate cu regulamentele GDPR.",
    gdpr_accept: "Accept",
    gdpr_purpose: "Scop: Identificarea contului pentru programul de fidelitate si referire Purple INK.",

    // Cookie Consent
    cookie_banner: "Folosim cookie-uri esentiale pentru a asigura functionarea corecta a acestui site. Continuand navigarea, accepti utilizarea cookie-urilor noastre.",
    cookie_accept: "Accept",
    cookie_policy_link: "Politica Cookie",
    cookie_policy_title: "Politica Cookie",
    cookie_policy_intro: "Aceasta Politica Cookie explica modul in care Purple INK Tattoo Studio foloseste cookie-urile si tehnologii similare pe site-ul nostru.",
    cookie_what_title: "Ce Sunt Cookie-urile?",
    cookie_what_text: "Cookie-urile sunt fisiere text mici plasate pe dispozitivul tau cand vizitezi un site web. Ele ajuta site-ul sa iti retina preferintele si sa imbunatateasca experienta de navigare.",
    cookie_types_title: "Cookie-urile Pe Care Le Folosim",
    cookie_essential_title: "Cookie-uri Esentiale",
    cookie_essential_text: "Aceste cookie-uri sunt necesare pentru functionarea corecta a site-ului. Ele permit functii de baza precum autentificarea, preferintele de limba si gestionarea sesiunii. Aceste cookie-uri nu colecteaza date personale in scopuri de marketing.",
    cookie_list_auth: "Token de autentificare (JWT) — te mentine autentificat in siguranta",
    cookie_list_lang: "Preferinta de limba — retine alegerea ta EN/RO",
    cookie_list_cookie: "Consimtamant cookie — retine acceptarea cookie-urilor",
    cookie_list_gdpr: "Consimtamant GDPR — inregistreaza acceptarea privind confidentialitatea datelor",
    cookie_third_title: "Cookie-uri Terte",
    cookie_third_text: "Nu folosim cookie-uri de urmarire, analiza sau publicitate terte.",
    cookie_rights_title: "Drepturile Tale",
    cookie_rights_text: "Poti sterge cookie-urile oricand din setarile browserului. Retine ca dezactivarea cookie-urilor esentiale poate afecta functionalitatea site-ului.",
    cookie_contact_title: "Contact",
    cookie_contact_text: "Daca ai intrebari despre practicile noastre privind cookie-urile, contacteaza-ne prin sectiunea Contact a site-ului nostru.",
    cookie_updated: "Ultima actualizare: Februarie 2026",

    // Admin Consent Column
    col_consent: "Consimtamant",
    consent_yes: "Acceptat",
    consent_no: "In asteptare",

    // Appointments
    tab_appointments: "Programari",
    apt_title: "Calendar Programari",
    apt_new: "Programare Noua",
    apt_date: "Data",
    apt_time: "Ora",
    apt_duration: "Durata (ore)",
    apt_client_name: "Numele Clientului *",
    apt_phone: "Telefon (optional)",
    apt_phone_note: "Sters automat dupa ora programarii",
    apt_description: "Descriere Tatuaj",
    apt_advance: "Avans Platit",
    apt_advance_amount: "Suma",
    apt_price: "Preț",
    apt_remaining: "Rest de plată",
    apt_paid_full: "Plătit integral",
    apt_create: "Creeaza Programare",
    apt_creating: "Se creeaza...",
    apt_edit: "Editeaza Programare",
    apt_save: "Salveaza",
    apt_saving: "Se salveaza...",
    apt_delete: "Sterge",
    apt_delete_confirm: "Stergi programarea pentru {name} din {date}?",
    apt_reassign: "Reatribuie",
    apt_reassign_title: "Reatribuie Programare",
    apt_reassign_desc: "Muta aceasta programare la un alt artist.",
    apt_no: "Nicio programare pentru aceasta data",
    apt_no_upcoming: "Nicio programare viitoare",
    apt_today: "Azi",
    apt_phone_hidden: "Numar sters",
    apt_all_artists: "Toti Artistii",
    apt_filter_artist: "Filtreaza dupa artist",
    apt_upcoming: "Viitoare",
    apt_past: "Trecute",
    apt_reschedule: "Reprogrameaza",
  },
};

export default translations;
